import {
  PRODUCT_CATALOGS_PATH,
  ROOT_PATH,
} from 'common/api/queryKeys/dataSourcesKeys'
import { TreeNode } from 'common/components/catalog/Catalog'
import { CustomerAttributes } from 'features/personalization/api'

export const keys = {
  customerAttributes: ({
    accountId,
    catalogueAttributeId,
    region,
  }: {
    accountId: string
    catalogueAttributeId: string
    region: string
  }) => [
    ROOT_PATH,
    'customer-attributes',
    accountId,
    catalogueAttributeId,
    region,
  ],
  customerAttributeRecords: ({ accountId }: { accountId: string }) => [
    ROOT_PATH,
    'customer-attributes-records',
    accountId,
  ],
  allProductCatalogQueries: [ROOT_PATH, PRODUCT_CATALOGS_PATH],
  productCatalogCategories: ({
    accountId,
    region,
    catalogId,
  }: {
    accountId: string | undefined
    region: string | undefined
    catalogId: string | undefined
  }) => [ROOT_PATH, PRODUCT_CATALOGS_PATH, accountId, region, catalogId],
  categoryDetails: ({
    accountId,
    region,
    catalogId,
    ccnPath,
  }: {
    accountId: string | undefined
    region: string | undefined
    catalogId: string | undefined
    ccnPath: string | undefined
  }) => [
    ROOT_PATH,
    PRODUCT_CATALOGS_PATH,
    'category-details',
    accountId,
    region,
    catalogId,
    ccnPath,
  ],
  categoryProducts: ({
    accountId,
    region,
    catalogId,
    categoryId,
  }: {
    accountId: string | undefined
    region: string | undefined
    catalogId: string | undefined
    categoryId: string | undefined
  }) => [
    ROOT_PATH,
    PRODUCT_CATALOGS_PATH,
    'category-products',
    accountId,
    region,
    catalogId,
    categoryId,
  ],
  productCatalogs: ({
    accountId,
    region,
  }: {
    accountId: string | undefined
    region: string | undefined
  }) => [ROOT_PATH, PRODUCT_CATALOGS_PATH, accountId, region],
  productCatalogSettings: ({
    accountId,
    productCatalogId,
    region,
  }: {
    accountId: string
    productCatalogId: string
    region: string
  }) => [
    ROOT_PATH,
    PRODUCT_CATALOGS_PATH,
    'settings',
    accountId,
    productCatalogId,
    region,
  ],
  productCatalogSearch: ({
    accountId,
    catalogId,
    region,
    query,
    page,
    pageSize,
  }: {
    accountId: string | undefined
    catalogId: string | undefined
    region: string | undefined
    query: string | undefined
    page: number | undefined
    pageSize: number | undefined
  }) => [
    ROOT_PATH,
    PRODUCT_CATALOGS_PATH,
    accountId,
    region,
    catalogId,
    'search',
    query,
    page,
    pageSize,
  ],
  productDetails: ({
    accountId,
    catalogId,
    categoryId,
    productId,
    region,
  }: {
    accountId: string | undefined
    catalogId: string | undefined
    categoryId: string | undefined
    productId: string | undefined
    region: string | undefined
  }) => [
    ROOT_PATH,
    PRODUCT_CATALOGS_PATH,
    accountId,
    region,
    catalogId,
    'categories',
    categoryId,
    'products',
    productId,
  ],
  categoryPerformance: ({
    accountId,
    customerAttributes,
    personalizationId,
    productCategories,
  }: {
    accountId: string
    personalizationId: string
    customerAttributes: CustomerAttributes | undefined
    productCategories: TreeNode | undefined
  }) => [
    ROOT_PATH,
    'category-performance',
    accountId,
    personalizationId,
    customerAttributes,
    productCategories,
  ],
  account: ({ accountId, userId }: { accountId: string; userId: string }) => [
    ROOT_PATH,
    'account-info',
    accountId,
    userId,
  ],
} as const
